/*
 * @Author: Pension 744056574@qq.com
 * @Date: 2022-08-26 17:21:58
 * @LastEditors: Pension 744056574@qq.com
 * @LastEditTime: 2022-10-27 14:50:29
 * @FilePath: /njyx-frontend-pc/packages/share/utils/reduceTopNavPath.ts
 * @Description:增加顶部路径的函数
 *
 */
import { da } from "date-fns/locale";
import localforage from "localforage";
export default function reducePath(length: number, path: string) {
  //   let localCachePath = localStorage.getItem("menuPath")
  //   if (localCachePath) {
  //     let pathArr = JSON.parse(localCachePath)
  //     let i = 0
  //     while (i < length) {
  //       pathArr.pop()
  //       i++
  //     }
  //     const tabItem = new CustomEvent("updateMenuPath", { detail: pathArr })
  //     window.dispatchEvent(tabItem)
  //   }

  localforage.getItem("allActive3LevelMenuData").then((data: any) => {
    for (let i = 0; i < data.length; i++) {
      if (data[i].isClick) {
        data.splice(i, 1);
        i--;
        break;
      } else {
        data[i].isClick = false;

        if (path == data[i].url) {
          data[i].isClick = true;
          localStorage.setItem("btnList", JSON.stringify(data[i].btnList)); //存储按钮权限
        }
      }
    }

    localforage.setItem("allActive3LevelMenuData", data).then((value: any) => {
      const tabItem = new CustomEvent("allActive3LevelMenuData", {
        detail: { allActive3LevelMenuData: value },
      });
      window.dispatchEvent(tabItem);
    });
  });
}
